export const secondsToMinutes = (seconds) => {
    return Math.round((seconds / 60) * 100) / 100
};


export const formatResultTime = (time) => {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;


    return minutes + ":" + seconds + " minutes";
}


// WEBPACK FOOTER //
// ./src/services/time/time-service.js